import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import locale from '@/configs/locale.js'

import zhHant from 'vuetify/src/locale/zh-Hant.ts'

Vue.use(Vuetify)

const opts = {
  icons: {
    iconfont: 'mdi'
  },
  lang: {
    locales: { zhHant },
    current: locale.currentLocale
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#9C27B0',
        secondary: '#FF9800'
      }
    }
  }
}

export default new Vuetify(opts)
